import ImpressionDivWrapper from '@/components/Common/ImpressionDivWrapper';
import { getSVG } from '@/components/Common/styles/mixins';
import CardsSwiper from './CardsSwiper';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import React, { FC, useCallback, useContext, useMemo } from 'react';

import BenefitCards from './BenefitCards';
import styles from './index.module.scss';

const KeyVisual: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/${path}`), []);
  const [logo, title] = useMemo(() => ['v33/logo.svg', 'v9/title.svg'].map(getResourcePath), []);
  const cards = useMemo(
    () =>
      [
        { src: 'v9/card-01-1.png', alt: '놀카드 디자인 1' },
        { src: 'v9/card-02-1.png', alt: '놀카드 디자인 2' },
        { src: 'v9/card-03-1.png', alt: '놀카드 디자인 3' },
        { src: 'v9/card-04-1.png', alt: '놀카드 디자인 4' },
        { src: 'v9/card-05-1.png', alt: '놀카드 디자인 5' },
        { src: 'v9/card-06-1.png', alt: '놀카드 디자인 6' },
      ].map(({ src, alt }) => ({ src: getResourcePath(src), alt })),
    [],
  );

  return (
    <ImpressionDivWrapper
      logData={{
        pageName: store.pageName,
        objectContainer: '놀사람을 위한 NOL 카드',
        motherPageVersion: store.version,
        motherPageSectionType: '프로모션',
        motherPageSectionName: '놀사람을 위한 NOL 카드',
      }}
    >
      <div className={styles.container}>
        <div className={styles.swipeCards}>
          <CardsSwiper images={cards} />
        </div>
        <div className={styles.logo}>
          <img src={logo} alt={'NOL | 트리플 X 현대카드'} />
        </div>
        <div className={styles.subTitle}>
          <p>놀수록 놀라운 혜택</p>
        </div>
        <img className={styles.title} src={title} alt={'NOL 카드'} />
        <div className={styles.subTitleBottom}>
          <p>NOL · 트리플</p>
        </div>

        {/* 혜택 영역 */}
        <BenefitCards />
      </div>
    </ImpressionDivWrapper>
  );
};

export default observer(KeyVisual);
